import { ITreeStructure } from '../models/treeStructure'

import { getAllDescendantsForItem } from './getAllDescendantsForItem'

export const getAncestorsToRemove = (
  item: ITreeStructure,
  selectedItems: ITreeStructure[]
): ITreeStructure[] => {
  const ancestor = item.parent
  if (!ancestor) {
    return []
  }

  const allDescendants = getAllDescendantsForItem(ancestor).filter(
    (it) => it.itemId !== ancestor.itemId
  )

  const hasSomeCheckedDescendants = allDescendants.some((descendant) => {
    return selectedItems.some((selected) => selected.itemId === descendant.itemId)
  })

  if (hasSomeCheckedDescendants) {
    return []
  }

  return [
    ancestor,
    ...getAncestorsToRemove(
      ancestor,
      selectedItems.filter((selected) => selected.itemId !== ancestor.itemId)
    ),
  ]
}
